import { useMemo } from 'react';
import { getEcommerceFieldsConfig } from '../../../config/ecommerceFieldsConfig';

export default function useEcommerceFields(ecommerceName) {
  const config = useMemo(
    () => getEcommerceFieldsConfig(ecommerceName),
    [ecommerceName]
  );

  const validateRequiredFields = (values) => {
    return config.requiredFields.some((field) => {
      const value = values[field];
      return !value || (typeof value === 'string' && !value.trim());
    });
  };

  return {
    config,
    validateRequiredFields,
  };
}
